
import link from './date-format.link';

export default function dateFormat () {
	return {
		require:'^ngModel',
		restrict:'A',
		link
	};
};

dateFormat.$inject = [];



// WEBPACK FOOTER //
// ./src/directive/date-format/date-format.js